import { TemplateNames } from '@quromedical/communication';
import { TemplateTypeCode } from '@quromedical/fhir-common';
import { z } from 'zod';
import { UUIDSchema } from '../domain/models';
import { PaginationSchema } from '../domain/pagination';
import {
  PaginatedBundleSchema,
  PartialPeriodSchema,
  systemSchema,
} from '../domain/schema';

export const TemplateTypeSchema = z.nativeEnum(TemplateTypeCode);
export const TemplateNameSchema = z.nativeEnum(TemplateNames);

//TODO this model needs refactoring. We don't need all this information on the frontend
export const MessageTemplateSchema = z.object({
  id: UUIDSchema,
  name: TemplateNameSchema.or(z.string()),
  content: z.string(),
  templateId: z.string(),
  type: TemplateTypeSchema,
  active: z.boolean(),
  effectivePeriod: PartialPeriodSchema,
  system: systemSchema,
});

export const MessageTemplateGetResponseSchema = MessageTemplateSchema;

export const MessageTemplateGetAllResponseSchema = PaginatedBundleSchema.extend(
  {
    templates: MessageTemplateGetResponseSchema.array(),
  },
);

export const MessageTemplateSearchSchema = PaginationSchema.extend({
  name: TemplateNameSchema.optional(),
  active: z.boolean().optional(),
  type: TemplateTypeSchema.optional(),
});

export type MessageTemplate = z.infer<typeof MessageTemplateSchema>;
export type MessageTemplateGetAllResponse = z.infer<
  typeof MessageTemplateGetAllResponseSchema
>;
export type MessageTemplateGetResponse = z.infer<
  typeof MessageTemplateGetResponseSchema
>;
export type MessageTemplateSearchParams = z.infer<
  typeof MessageTemplateSearchSchema
>;
